import { render } from "./CommentCard.vue?vue&type=template&id=3190baa0&scoped=true"
import script from "./CommentCard.vue?vue&type=script&lang=js"
export * from "./CommentCard.vue?vue&type=script&lang=js"

import "./CommentCard.vue?vue&type=style&index=0&id=3190baa0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3190baa0"]])

export default __exports__